import { Component, EventEmitter, input, Input, InputSignal, Output, ViewEncapsulation } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'ph-icon-wrapper',
    templateUrl: './ph-icon-wrapper.component.html',
    styleUrls: ['./ph-icon-wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None,
	imports: [SHARED_MODULES, PhIconComponent],
    standalone: true
})

export class PhIconWrapperComponent {

    loading: InputSignal<boolean> = input<boolean>(false);
	@Input() id: string;
	@Input() icon: string;
	@Input() blocked: boolean = false;
	@Input() disabled: boolean = false;
	@Input() active: boolean = false;
	@Input() hover: boolean = false;
	@Input() negative: boolean = false;
	@Input() size: number = 40;
	@Input() iconSize: number = 20;

	@Output() iconClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}